module.exports = __webpack_public_path__ + "img/neutralAvatar-51eb07c86f2c005e37a161f0211c63ce.svg";